import { render, staticRenderFns } from "./collecting.vue?vue&type=template&id=fc624964&scoped=true&"
import script from "./collecting.vue?vue&type=script&lang=js&"
export * from "./collecting.vue?vue&type=script&lang=js&"
import style0 from "./collecting.vue?vue&type=style&index=0&id=fc624964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc624964",
  null
  
)

component.options.__file = "collecting.vue"
export default component.exports